import { render, staticRenderFns } from "./o-steps-panel.vue?vue&type=template&id=2640b6d6&"
import script from "./o-steps-panel.vue?vue&type=script&lang=js&"
export * from "./o-steps-panel.vue?vue&type=script&lang=js&"
import style0 from "./o-steps-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports